'use client';

import { useState } from 'react';

import Link from 'next/link';
import { useRouter, usePathname } from 'next/navigation';

import {
  Popover, PopoverContent, PopoverTrigger,
} from '@heroui/react';

import { isMobile } from 'react-device-detect';
import { GrMoney } from 'react-icons/gr';
import { IoCopyOutline } from 'react-icons/io5';

import { LiaFileInvoiceDollarSolid } from 'react-icons/lia';

import { RiLogoutCircleLine } from 'react-icons/ri';
import { SlUser } from 'react-icons/sl';

import { useAuthStore } from '@/stores/userStore';

import Avatar from '@/stories/molecules/avatar/Avatar';

import { useAuth } from '@/core/auth/client/AuthProvider';

import LoadingSpinner from '@/components/common/LoadingSpinner';

import { Skeleton } from '@/components/ui/skeleton';

import { useToast } from '@/components/ui/use-toast';

const UserMenu = () => {
  const pathname = usePathname();
  const router = useRouter();
  const [isLoading, setIsLoading] = useState(false);
  const [isActive, setActive] = useState(false);

  const {
    account, clearStore,
  } = useAuthStore();

  const { signOut } = useAuth();
  const { toast } = useToast();

  const toggleActive = () => {
    setActive(!isActive);
  };

  const handleHeaderBarClick = () => {
    toggleActive();
  };

  const handleLogout = async () => {
    try {
      await signOut();
      clearStore();
      localStorage.removeItem('email');
      localStorage.removeItem('phone');
      localStorage.removeItem('user_id');

      if (pathname.startsWith('/dashboard')) {
        router.push('/');
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Logout failed', error);
    }
  };

  const showSpinner = () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 300);
  };

  if (!account) {
    return (
      <div className="relative">
        <Skeleton className="w-10 h-10 rounded-full bg-sivarbet-border" />
      </div>
    );
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(account?.nick || '').then(() => {
      toast({
        title: 'Nickname copiado',
        description: 'El nickname ha sido copiado al portapapeles',
      });
    });
  };
  return (
    <div className="relative">
      {isLoading && <LoadingSpinner />}
      <Popover showArrow placement="bottom" className="z-0">
        <PopoverTrigger>
          <button type="button" className="relative px-3 cursor-pointer" onClick={handleHeaderBarClick}>
            <Avatar />
          </button>
        </PopoverTrigger>
        <PopoverContent className="px-4 py-2 bg-background rounded-2xl font-text text-base flex flex-col items-start gap-3">
          <button
            type="button"
            className="flex flex-row items-center justify-center gap-6 p-2 rounded-xl bg-primary-50/40 text-center font-semibold cursor-pointer w-full"
            onClick={handleCopy}
          >
            <span className="bg-gradient-to-r from-primary-500 to-primary-600 bg-clip-text text-transparent">
              {account.nick}
            </span>
            <IoCopyOutline className="cursor-pointer" />

          </button>

          <Link href="/dashboard" prefetch>
            <button
              type="button"
              onClick={showSpinner}
              className="flex flex-row items-center cursor-pointer focus:text-sivarbet-text"
            >
              <SlUser className="mr-2" />
              <span>Perfil</span>
            </button>
          </Link>
          <hr className="w-11/12 mx-auto bg-default-100" />
          <Link
            href="/dashboard/transactions"
            prefetch
          >
            <button
              type="button"
              onClick={showSpinner}
              className="flex flex-row items-center cursor-pointer focus:text-sivarbet-text"
            >
              <LiaFileInvoiceDollarSolid className="mr-2" />
              <span>Transacciones</span>
            </button>
          </Link>
          <hr className="w-11/12 mx-auto bg-default-100" />
          <Link
            href={isMobile ? '/deposito?page=retiros' : '/dashboard/withdrawals'}
            prefetch
          >
            <button
              type="button"
              onClick={showSpinner}
              className="flex flex-row items-center cursor-pointer focus:text-sivarbet-text"
            >
              <GrMoney className="mr-2" />
              <span>Retiros</span>
            </button>
          </Link>
          <hr className="w-11/12 bg-default-100 mx-auto" />
          <button type="button" onClick={handleLogout} className="flex flex-row items-center cursor-pointer">
            <RiLogoutCircleLine className="mr-2 text-default-500" />
            <span className="fw-bold text-default-500">Cerrar Sesión</span>
          </button>
        </PopoverContent>
      </Popover>

    </div>
  );
};

export default UserMenu;
